import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ru from './locales/ru.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ru: { translation: ru }, en: { translation: en } },
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

// Native form controls (notably date/time pickers) use the document language.
const syncDocumentLanguage = (language: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = language.startsWith('en') ? 'en' : 'ru';
};
syncDocumentLanguage(i18n.resolvedLanguage || i18n.language || 'ru');
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
